// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1cSPY","vLegacy":"SelectSecondary_vLegacy__2BDzH","error":"SelectSecondary_error__3CPOl","disabled":"SelectSecondary_disabled__2-9Q_"};